import { Badge } from "@/core/components/ui/badge";
import { PAYROLL_RUN_STATUS } from "@/payroll/constants";
import { PayrollRunStatus } from "@/payroll/payroll.d";
import { PAYROLL_RUN_STATUS_UI } from "./payroll-run-status-ui";

interface PayrollRunStatusBadgeProps {
  status: PayrollRunStatus;
  isManual?: boolean;
}

export const PayrollRunStatusBadge = ({
  status,
  isManual = false,
}: PayrollRunStatusBadgeProps) => {
  // If manual and completed, show Manual badge with gold variant
  if (isManual && status === PAYROLL_RUN_STATUS.completed) {
    return (
      <Badge variant="gold" className="w-24 justify-center">
        Manual
      </Badge>
    );
  }

  const { badgeVariant, label } = PAYROLL_RUN_STATUS_UI[status];

  return (
    <Badge variant={badgeVariant} className="w-24 justify-center">
      {label}
    </Badge>
  );
};
